/**
 * Toma un unixTime y lo convierte a una fecha en formato string.
 * 
 * @param {number} unixTime Un unix time (número de segundos desde el epoch).
 * @returns {string} La fecha correspondiente en formato string.
 */
export default function unixTimeToDateTime(unixTime: number): string {
  let dateObject = new Date(1000*unixTime);
  dateObject.setHours(
    dateObject.getHours()
    + dateObject.getTimezoneOffset() / 60
  );

  return dateObject.toLocaleString("es-cl");
}